"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AttachmentCleanUpProcessor", {
    enumerable: true,
    get: function() {
        return AttachmentCleanUpProcessor;
    }
});
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _NcPluginMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/helpers/NcPluginMgrv2"));
const _attachmentHelpers = require("~/helpers/attachmentHelpers");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const retentionDays = process.env.NC_ATTACHMENT_RETENTION_DAYS || 10;
let AttachmentCleanUpProcessor = class AttachmentCleanUpProcessor {
    async job(job) {
        // if retentionDays is set to 0, clean up is disabled
        if (+retentionDays === 0) {
            return;
        }
        this.debugLog(`job started for ${job.id}`);
        const ncMeta = _Noco.default.ncMeta;
        const storageAdapter = await _NcPluginMgrv2.default.storageAdapter();
        const storageAdapterName = storageAdapter.name;
        const orphanedFilesQueryBuilder = ncMeta.knexConnection(_globals.MetaTable.FILE_REFERENCES).select('file_url').max('updated_at', {
            as: 'last_updated_at'
        }).groupBy('file_url').havingRaw('COUNT(*) = COUNT(CASE WHEN deleted THEN 1 END)');
        const orphanedFiles = await orphanedFilesQueryBuilder.select('file_url');
        for (const file of orphanedFiles){
            if (new Date(file.last_updated_at).getTime() > new Date().getTime() - +retentionDays * 24 * 60 * 60 * 1000) {
                continue;
            }
            let relativePath;
            const rootKey = await ncMeta.knexConnection(_globals.MetaTable.FILE_REFERENCES).where('file_url', file.file_url).select('storage', 'file_url').whereNotNull('storage').first();
            if (rootKey) {
                file.storage = rootKey.storage;
                // skip if file is not stored in the current storage adapter
                if (file.storage !== storageAdapterName) {
                    continue;
                }
            }
            if (storageAdapterName === 'Local') {
                relativePath = file.file_url.replace(/^download\//, '');
            } else {
                relativePath = (0, _attachmentHelpers.getPathFromUrl)(file.file_url, true);
            }
            try {
                await storageAdapter.fileDelete(_path.default.join('nc', 'uploads', relativePath));
                const thumbnails = [
                    'tiny.jpg',
                    'small.jpg',
                    'card_cover.jpg'
                ];
                for (const thumb of thumbnails){
                    await storageAdapter.fileDelete(_path.default.join('nc', 'thumbnails', relativePath, thumb));
                }
                await ncMeta.knexConnection(_globals.MetaTable.FILE_REFERENCES).where('file_url', file.file_url).del();
            } catch (e) {
                this.debugLog(`error deleting file ${file.file_url}: ${e.message}`);
            }
        }
        this.debugLog(`job completed for ${job.id}`);
    }
    constructor(){
        this.debugLog = (0, _debug.default)('nc:jobs:attachment-clean-up');
    }
};
